'use client'

import { useEffect } from 'react'
import { useDemo } from './DemoProvider'
import { runCommunityDemo } from '@/features/community/demo/communityDemoEngine'

export function DemoEventBridge() {
  const { startDemo } = useDemo()

  useEffect(() => {
    async function onStart(e: Event) {
      const ev = e as CustomEvent
      const { scope, script } = ev.detail || {}
      if (!scope || !script) return

      startDemo(scope, script)

      if (scope === 'community' && script === 'owner-onboarding') {
        await runCommunityDemo()
      }
    }

    window.addEventListener('demo:start', onStart as EventListener)
    return () =>
      window.removeEventListener('demo:start', onStart as EventListener)
  }, [startDemo])

  return null
}